<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
        <!-- Logo -->
        <div class="logo">
            <a routerLink="/"><img src="assets/img/logo.png" width="200" alt="Tommys Fahrschule Logo"/></a>
        </div>

        <!-- Mobile toggle button -->
        <button class="navbar-toggler" type="button" (click)="isMenuCollapsed = !isMenuCollapsed">
            <span class="navbar-toggler-icon"></span>
        </button>

        <!-- Nav items -->
        <div [ngClass]="{'collapse navbar-collapse': true, 'show': !isMenuCollapsed}" id="navbarSupportedContent">
            <ul class="navbar-nav">
                <li class="nav-item"><a routerLink="/about" class="nav-link">Über uns</a></li>
                <li class="nav-item"><a routerLink="/klassen" class="nav-link">Klassen</a></li>
                <li class="nav-item"><a routerLink="/team" class="nav-link">Das Team</a></li>
                <li class="nav-item"><a routerLink="/kurse" class="nav-link">Kurse</a></li>
                <li class="nav-item"><a routerLink="/preise" class="nav-link">Preise</a></li>
                <li class="nav-item"><a routerLink="/kontakt" class="nav-link">Kontakt</a></li>
            </ul>

            <!-- CTA Button -->
            <div class="others-option d-flex align-items-center">
                <a routerLink="/kontakt" class="default-btn">Jetzt anmelden</a>
            </div>
        </div>
    </div>
</nav>
